module.exports = __webpack_public_path__ + "static/img/logo.b607d333.png";